module.exports = __webpack_public_path__ + "img/shuguikj.9070f9a5.png";